import { ComboboxBase } from './ComboboxBase'
import type {
  ComboboxClassNames,
  ComboboxHandle,
  ComboboxModeProps,
  MultipleProps,
  SharedProps,
} from './types'

export type MultiSelectHandle = ComboboxHandle
export type MultiSelectClassNames<T> = ComboboxClassNames<T>
export type MultiSelectProps<T = string> = SharedProps<T> &
  ComboboxModeProps<T> &
  Omit<MultipleProps<T>, 'multiple'>

export function MultiSelect<T = string>(props: MultiSelectProps<T>) {
  return <ComboboxBase<T> multiple {...props} />
}
